export class NullLogger {
    debug(_message, ..._optionalParams) { }
    error(_message, ..._optionalParams) { }
    info(_message, ..._optionalParams) { }
    log(_message, ..._optionalParams) { }
    warn(_message, ..._optionalParams) { }
}
//# sourceMappingURL=null-logger.js.map